import { render, staticRenderFns } from "./newsrotation.vue?vue&type=template&id=2cde0c34&scoped=true&"
import script from "./newsrotation.vue?vue&type=script&lang=js&"
export * from "./newsrotation.vue?vue&type=script&lang=js&"
import style0 from "./newsrotation.vue?vue&type=style&index=0&id=2cde0c34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde0c34",
  null
  
)

export default component.exports